import { render, staticRenderFns } from "./PrepayTab.vue?vue&type=template&id=ebf04722&scoped=true"
import script from "./PrepayTab.vue?vue&type=script&lang=js"
export * from "./PrepayTab.vue?vue&type=script&lang=js"
import style0 from "./PrepayTab.vue?vue&type=style&index=0&id=ebf04722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf04722",
  null
  
)

export default component.exports